import React from 'react';
import ReactDOM from 'react-dom/client';
import { initI18n } from '@shared/i18n/index.js';
import App from '@/App.jsx';
import '@/index.css';

// Sets <html lang>, which the Greek uppercase rules in tokens.css depend on.
initI18n();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
